export default __webpack_public_path__ + "static/media/about-me-img-04.93d28c3c.jpg";